import { callBackend } from '../utils/api';

export {
    OffboardingContractError,
    parseOffboardingApiError,
    validateTeamMemberDeletionPreview,
    validateTeamMemberDeletionResult,
} from './teamMemberOffboardingContracts';

export function requestTeamMemberDeletionPreview(firebaseUid) {
    return callBackend(
        `admin/users/${encodeURIComponent(firebaseUid)}/deletion-preview`,
        'POST',
        {},
    );
}

export function permanentlyDeleteTeamMember(firebaseUid, previewToken, confirmation) {
    return callBackend(
        `admin/users/${encodeURIComponent(firebaseUid)}`,
        'DELETE',
        {
            preview_token: previewToken,
            confirmation,
        },
    );
}
